import { type FC } from "react";
import { Outlet, useParams } from "react-router-dom";

import { type AbsoluteRoute, type RouteParams } from "../../core/routes";
import { PageContentSpinner } from "../../layout/components";
import { useOrganizationMetadata } from "../../shared/hooks";

import { AssetsPermissionDeniedCard } from "./AssetsPermissionDeniedCard";

export const AssetsContainer: FC = () => {
    const { orgId } = useParams<RouteParams[AbsoluteRoute.ORG_ASSETS]>();

    const { loading, error } = useOrganizationMetadata(orgId ?? "", !orgId);

    if (loading) {
        return <PageContentSpinner />;
    }

    if (error !== undefined) {
        return <AssetsPermissionDeniedCard />;
    }

    return <Outlet />;
};
